import { useState } from "react";
import { sendEmail } from "../../../api/contacts";
import toast from "react-hot-toast";
import { FiSend } from "react-icons/fi";

export default function UnsentSend({ token, templateId, setResult, refreshUnsent, trackOpens = false, includeUnsubscribe = false }) {
  const [progress, setProgress] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    setProgress([]);
    let batchResults = [];
    let batch = 1;
    let totalSent = 0;

    while (true) {
      const res = await sendEmail(token.access, "", templateId, trackOpens, includeUnsubscribe);

      if (res.sent_count === 0) break;

      batchResults.push(`Batch ${batch}: Sent ${res.sent_count}`);
      setProgress([...batchResults]);
      totalSent += res.sent_count;
      batch++;
    }

    toast.success(`Completed! Total Sent: ${totalSent}`);
    setResult({ sent_count: totalSent, skipped_count: 0, failed_count: 0 });
    refreshUnsent();
    setLoading(false);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border space-y-4">
      <button
        onClick={handleSend}
        className="bg-blue-600 text-white px-6 py-2 rounded flex items-center gap-2"
        disabled={loading}
      >
        <FiSend /> {loading ? "Sending..." : "Send Unsent Emails"}
      </button>

      {progress.length > 0 && (
        <div className="bg-blue-50 border p-4 rounded">
          {progress.map((p, i) => (
            <p key={i} className="text-blue-800 text-sm">{p}</p>
          ))}
        </div>
      )}
    </div>
  );
}
